/**
 * Builds the "Markers" dropdown HTML for a single map panel. The checkbox list is
 * limited to the equipment types present on that panel, so a panel only shows the
 * marker toggles that can actually appear on it.
 *
 * @param {object} EventMarkerService service exposing constructMarkerCheckboxes
 * @param {Array} equipmentTypes equipment types associated with the panel
 * @returns {string} dropdown html
 */
export default function markerControlsTemplate(EventMarkerService, equipmentTypes) {
  return `<div class="map-marker-dropdown-container">
        <button class="map-marker-dropdown btn"
            role="button"
            tabindex="0"
            title="Show marker checkboxes"
            aria-label="Show marker checkboxes"
            aria-pressed="true"
            draggable="false"
            ng-click="$event.stopPropagation(); toggleDropdown($event)"
        >
          Markers
        </button>
        <div class="map-marker-dropdown-sibling">
          ${EventMarkerService.constructMarkerCheckboxes(equipmentTypes)}
        </div>
      </div>`;
}
